module.exports = __webpack_public_path__ + "img/rent3.de674b7b.jpg";